import { fg } from '@confluence/feature-gating';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { PAGE_TREE_STATUSES } from '@confluence/page-tree/entry-points/pageTreeStatuses.ts';
import { preloadPageTree } from '@confluence/page-tree/entry-points/preloadPageTree.ts';

import DatabaseContainerQuery, {
	type DatabaseContainerQuery$data as DatabaseContainerQueryType,
	type DatabaseContainerQuery$variables as DatabaseContainerQueryVariables,
} from './__generated__/DatabaseContainerQuery.graphql.ts';

export async function preloadDatabaseData(spaceKey: string, contentId: string): Promise<any> {
	return waitForAllReturnWhenError([
		preloadContentData(contentId, spaceKey),
		preloadContentTree(contentId, spaceKey),
	]);
}

async function preloadContentData(contentId: string, spaceKey: string): Promise<void> {
	await query<DatabaseContainerQueryType, DatabaseContainerQueryVariables>({
		query: DatabaseContainerQuery,
		variables: {
			contentId,
			spaceKey: spaceKey === '_' && fg('cc-cns-28262-fix-bad-space-key-preload') ? null : spaceKey,
			// The DSP query doesn't currently user the content version value, so using a fixed value
			contentVersion: 1,
		},
	});
}

async function preloadContentTree(contentId: string, spaceKey: string): Promise<void> {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR && contentId) {
		await preloadPageTree({
			spaceKey,
			statuses: PAGE_TREE_STATUSES,
			isSuperAdmin: false,
			contentId,
		});
	}
}
